import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const ExternalLinkIcon = forwardRef(({ title = 'External Link Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 15 15" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M8.77 0h5.8c.24 0 .43.19.43.43v5.8c0 .39-.46.58-.73.31l-2.2-2.2L11 5.42 9.58 4 5.66 7.92a.5.5 0 0 0 0 .7l.72.72c.2.2.5.2.7 0L11 5.42v9.19a.4.4 0 0 1-.39.39H.39a.4.4 0 0 1-.39-.39V4.39A.4.4 0 0 1 .39 4h9.19l1.08-1.07-2.2-2.2A.43.43 0 0 1 8.77 0" })));
});
//# sourceMappingURL=external_link_icon.js.map